import AbstractViewManage from '@/class/view/AbstractViewManage'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { checkCharge } from '@/api/clearing/charge'
import {
  getBillingDetail,
  loadChargeOfBilling,
  loadJobOfBilling, recheckBilling,
  saveBilling
} from '@/api/clearing/billingNative'
import { getGridSelected } from '@/utils/agGrid'
import * as ReconciliationUtils from '@/class/cargo/model/utils/ReconciliationUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import * as BillingNativeUtils from '@/class/cargo/model/utils/BillingNativeUtils'
import { loadCharges } from '@/api/clearing/charge'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import lodash from 'lodash'
import { getLoading } from '@/utils/utilBaseElement'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { isReceivable } from '@/class/cargo/model/utils/ReconciliationUtils'
import * as BillingRateUtil from '@/class/cargo/model/utils/BillingRateUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import { TYPE_NAMES } from '../../../utils/class/AdvanceSelect'

export default class billDetailHp extends AbstractViewManage {
  constructor(view) {
    super(view)
  }

  // 保存账单
  async saveBillingDetail(affirm) {
    const billing = this._view.billing
    if (affirm) {
      billing.affirm = true
    } else {
      billing.affirm = false
    }
    if (billing.uuid) { // 编辑账单保存
      const charges = this.getAllCharges()
      const createCharges = []
      const updateCharges = []
      const removedCharges = billing.removedCharges
      const newCharges = []
      const editCharges = []
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i]
        if (charge['uuid'] && charge['dirty'] === true) {
          updateCharges.push(charge)
        } else if (!charge['uuid']) {
          charge['joinBilling'] = true
          createCharges.push(charge)
        }
        if (charge._charge) {
          if (charge._charge.uuid) {
            editCharges.push(charge._charge)
          } else {
            newCharges.push(charge._charge)
          }
        }
      }
      if (removedCharges && removedCharges.length > 0) {
        for (let j = 0; j < removedCharges.length; j++) {
          const removeCharge = removedCharges[j]
          if (removeCharge['uuid'] && removeCharge['dirty'] === true) {
            updateCharges.push(removeCharge)
          } else if (!removeCharge['uuid']) {
            createCharges.push(removeCharge)
          }
        }
      }
      billing.createCharges = createCharges
      billing.updateCharges = updateCharges
      billing.newCharges = newCharges
      billing.editCharges = editCharges
      if (billing.deletedChargeKeys && billing.deletedChargeKeys.length > 0) {
        const saveChargeKeySet = charges.filter(p => p.uuid).map(p => p.uuid)
        billing.deletedChargeKeys = billing.deletedChargeKeys.filter(p => !saveChargeKeySet.includes(p))
      }
      if (updateCharges.length > 0) {
        const dirtyCharges = await checkCharge(updateCharges).then(res => {
          return res.data
        })
        if (dirtyCharges && dirtyCharges.length > 0) {
          this._view.conflictCharges = [...dirtyCharges]
          this._view.showConflictChargeDialog = true
        } else {
          await this.continueSave()
        }
      } else {
        await this.continueSave()
      }
    } else { // 新增账单保存
      const passThrough = await this.validateBilling()
      if (!passThrough) {
        if (this._view.requestSource !== 'booking') {
          this._view.btnSaveEnable = false
        }
        return
      }
      if (passThrough) {
        billing.createCharges = this.getAllCharges()
        const newCharges = []
        const editCharges = []
        for (const charge of billing.createCharges) {
          if (charge._charge) {
            if (charge._charge.uuid) {
              editCharges.push(charge._charge)
            } else {
              newCharges.push(charge._charge)
            }
          }
        }
        billing.newCharges = newCharges
        billing.editCharges = editCharges
        if (billing.deletedChargeKeys && billing.deletedChargeKeys.length > 0) {
          const saveChargeKeySet = billing.createCharges.filter(p => p.uuid).map(p => p.uuid)
          billing.deletedChargeKeys = billing.deletedChargeKeys.filter(p => !saveChargeKeySet.includes(p))
        }
        this.saveBilling(billing)
      }
    }
  }
  // 继续保存
  async continueSave(dirtyCharges = []) {
    const billing = this._view.billing
    let updateCharges = billing.updateCharges
    let createCharges = billing.createCharges
    if (dirtyCharges.length > 0) {
      // 修改的费用
      if (updateCharges) {
        updateCharges = updateCharges.filter(charge => {
          if (charge['uuid']) {
            for (let j = 0; j < dirtyCharges.length; j++) {
              const dirtyCharge = dirtyCharges[j]
              if (charge['uuid'] !== dirtyCharge['uuid']) {
                return true
              }
            }
          }
        })
      }
      billing.updateCharges = updateCharges
      // 新增的费用
      if (createCharges) {
        createCharges = createCharges.filter(charge => {
          if (charge['uuid']) {
            for (let j = 0; j < dirtyCharges.length; j++) {
              const dirtyCharge = dirtyCharges[j]
              if (charge['chargeDiffChargeUuid'] !== dirtyCharge['uuid']) {
                return true
              }
            }
          } else if (charge._charge) {
            return true
          }
        })
      }
      billing.createCharges = createCharges
    }
    const passThrough = await this.validateBilling()
    if (passThrough) {
      this.saveBilling(billing)
    } else {
      if (this._view.requestSource !== 'booking') {
        this._view.btnSaveEnable = false
      }
      return
    }
  }
  // 调用后台方法，保存账单
  saveBilling(billing) {
    if (this._view.requestSource !== 'booking') {
      this._view.btnSaveEnable = true
    }
    // CARGO-8145 【海运出口-海运订舱极速版】国内账单页签，缺少我司银行
    if (!billing.bankAccountId && this._view.requestSource === 'booking') billing.bankAccountId = 0
    this._view.loading = getLoading()
    billing.currentOfficeId = this._view.$store.getters.currentOfficeId
    billing.location = this._view.location
    if (billing.revoked && ((billing.createCharges && billing.createCharges.length > 0) || (billing.updateCharges && billing.updateCharges.length > 0))) {
      billing.revoked = false
    }
    saveBilling(billing).then(res => {
      // 业务tab 入口保存账单
      if (this._view.requestSource === 'booking') {
        // 触发父级页面 重新加载
        this._view.$emit('reloadBillHandler')
      } else {
        // 将状态改为不可编辑
        this._view.isView = true
        if (res.data) {
          this._view.billingUuid = res.data.uuid
        }
        if (this._view.requestSource === 'reconciliation') {
          this._view.requestSource = 'bill'
        }
        this.queryBillingDetail()
      }
      this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
    }).catch().finally(() => {
      if (this._view.requestSource !== 'booking') {
        // 保存按钮状态改为可点击
        this._view.btnSaveEnable = false
      }
      this._view.loading.close()
    })
  }
  /**
   * 复核
   */
  btnRecheckBillingHandler(billings) {
    this._view.loading = getLoading()
    // const billings = []
    // billings.push(this._view.billing)
    recheckBilling(billings).then(() => {
      this.queryBillingDetail()
      this.$message.success(this.view.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
    }).finally(() => {
      this._view.loading.close()
    })
  }
  // 账单币种修改事件
  async currencyChangeEvent(obj = null) {
    this.updateBillingRate()
    if (obj) {
      const billing = this._view.billing
      billing.currency = obj.value
      const currency = billing.currency
      const sourceCurrency1 = billing.sourceCurrency1
      const sourceCurrency2 = billing.sourceCurrency2
      const sourceCurrency3 = billing.sourceCurrency3
      if (sourceCurrency1) {
        if (sourceCurrency1 !== currency) {
          // 不同币种做账单，如果找不到汇率则不能进行编辑汇率
          let rate = 0
          if (this._view.isSaveBillRate) {
            rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency1, billing.inputDate, null, true)
          } else {
            rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency1, billing.inputDate, billing.branchId, null, true)
          }
          billing.sourceRate1 = rate
          if (rate > 0) {
            this._view.billingFormParams.sourceRate1Enable = false
          } else {
            this._view.billingFormParams.sourceRate1Enable = true
          }
        } else { // 同币种做账单，汇率为1，此时汇率不可编辑
          billing.sourceRate1 = 1.0
          this._view.billingFormParams.sourceRate1Enable = true
        }
      } else {
        billing.sourceRate1 = 0.0
        this._view.billingFormParams.sourceRate1Enable = true
      }
      if (sourceCurrency2) {
        if (sourceCurrency2 !== currency) {
          // 不同币种做账单，如果找不到汇率则不能进行编辑汇率
          let rate = 0
          if (this._view.isSaveBillRate) {
            rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency2, billing.inputDate, null, true)
          } else {
            rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency2, billing.inputDate, billing.branchId, null, true)
          }
          billing.sourceRate2 = rate
          if (rate > 0) {
            this._view.billingFormParams.sourceRate2Enable = false
          } else {
            this._view.billingFormParams.sourceRate2Enable = true
          }
        } else { // 同币种做账单，汇率为1，此时汇率不可编辑
          billing.sourceRate2 = 1.0
          this._view.billingFormParams.sourceRate2Enable = true
        }
      } else {
        billing.sourceRate2 = 0.0
        this._view.billingFormParams.sourceRate2Enable = true
      }
      if (sourceCurrency3) {
        if (sourceCurrency3 !== currency) {
          // 不同币种做账单，如果找不到汇率则不能进行编辑汇率
          let rate = 0
          if (this._view.isSaveBillRate) {
            rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency3, billing.inputDate, null, true)
          } else {
            rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency3, billing.inputDate, billing.branchId, null, true)
          }
          billing.sourceRate3 = rate
          if (rate > 0) {
            this._view.billingFormParams.sourceRate3Enable = false
          } else {
            this._view.billingFormParams.sourceRate3Enable = true
          }
        } else { // 同币种做账单，汇率为1，此时汇率不可编辑
          billing.sourceRate3 = 1.0
          this._view.billingFormParams.sourceRate3Enable = true
        }
      } else {
        billing.sourceRate3 = 0.0
        this._view.billingFormParams.sourceRate3Enable = true
      }
      await this.calculateAmount()
    }
  }
  // 更新账单汇率
  updateBillingRate() {
    const localCurrency = this._view.currentBillingBranchId > 0 ? RateUtil.localCurrencyByOfficeId(this._view.currentBillingBranchId) : RateUtil.localCurrencyByOffice()
    if (this._view.isSaveBillRate) {
      this._view.billing.rate = BillingRateUtil.getForeignExchangeRateSafely(localCurrency, this._view.billing.currency, this._view.billing.inputDate)
    } else {
      this._view.billing.rate = RateUtil.getForeignExchangeRateSafely(localCurrency, this._view.billing.currency, this._view.billing.inputDate, this._view.currentBillingBranchId > 0 ? this._view.currentBillingBranchId : this._view.$store.getters.currentOfficeId)
    }
    this._view.billing.rate = NumberUtils.roundHalfUp(this._view.billing.rate, 8) // CARGO-7779
  }
  // 加入费用
  addBillChargeEvent() {
    if (this._view.billing.source === ChargeConstants.ETOWER_ONE.chineseName) {
      this.$message.warning(this.$t('CargoMsg.Cargo_BillNotAllowEditEtowerOne'))
      return
    }
    const charges = this.getAllCharges()
    const exceptKeys = []
    if (charges && charges.length > 0) {
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i]
        const key = charge['uuid']
        if (exceptKeys.indexOf(key) < 0) {
          exceptKeys.push(key)
        }
      }
    }
    this._view.addChargeCondition.exceptKeys = exceptKeys
    this._view.addChargeCondition.settlementAgentId = this._view.billing.settlementAgentId
    this._view.addChargeCondition.createBillWay = this._view.createBillWay
    if (this._view.createBillWay === 1) {
      this._view.searchItemModule = '5044'
    }
    if (this._view.reconciliationType === 'charge') {
      this._view.addChargeCondition.oversea = this._view.billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code ? 1 : 0
      this._view.addChargeCondition.accountId = this._view.billing.accountId
      this._view.addChargeCondition.hasBilling = 0
      this._view.addChargeCondition.exceptKeys = exceptKeys
      // 业务tab 入口保存账单
      if (this._view.requestSource === 'booking') {
        if (this._view.currentBillingBranchId > 0) {
          this._view.addChargeCondition.currentBillingBranchId = this._view.currentBillingBranchId
          // 费用创建人同组
          let roleCreatedBy = []
          if (this._view.departmentTeamUser != null) {
            roleCreatedBy = [... this._view.departmentTeamUser]
          }
          roleCreatedBy.push(this._view.$store.getters.userId)
          this._view.addChargeCondition.roleCreatedBy = roleCreatedBy
        }
      }
    } else {
      this._view.addChargeCondition.oversea = this._view.billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code ? 1 : 0
      this._view.addChargeCondition.accountId = this._view.billing.accountId
      this._view.addChargeCondition.hasBilling = 0
      this._view.addChargeCondition.exceptKeys = exceptKeys
    }
    this._view.showJoinChargeDialog = true
  }
  // 加入费用回调事件
  async addChargeCallBackEvent(charges) {
    this._view.showJoinChargeDialog = false
    const billing = this._view.billing
    if (charges && charges.length > 0) {
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i]
        charge['entity'] = 'charge'
        charge['dirty'] = true
        charge['chargeBillingAmount'] = 0
        charge['billingUuid'] = billing.uuid
        charge['billingNo'] = billing.billingNo
        if (this._view.reconciliationType === 'charge') {
          this._view.rowData.push(charge)
        } else {
          charge['amount'] = charge['chargeAmount']
          charge['currency'] = charge['chargeCurrency']
          charge['inputDate'] = charge['chargeInputDate']
          charge['dateCreated'] = charge['chargeDateCreated']
          this._view.rowData = lodash.cloneDeep(BillingNativeUtils.appendJobCharges(charge, this._view.rowData))
        }
      }
      // 判断账单是否为国内账单，如果满足，则重新计算账单的收支类型
      if (billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        billing.ar = isReceivable(this.getAllCharges(), billing.makeBillingPaymentReceiveMethod)
      }
      await this.refreshBilling()
      this.filterChange()
    }
  }
  // 编辑费用回调事件
  async editChargeCallBackEvent(charge) {
    const billing = this._view.billing
    if (charge) {
      charge['entity'] = 'charge'
      charge['dirty'] = true
      // charge['chargeBillingAmount'] = 0
      charge['billingUuid'] = billing.uuid
      charge['billingNo'] = billing.billingNo
      if (this._view.reconciliationType === 'charge') {
        const index = this._view.rowData.findIndex(p => p._charge && p._charge.refId && p._charge.refId === charge._charge.refId)
        if (index > -1) {
          this._view.rowData[index] = charge
          this._view.rowData = [...this._view.rowData]
        } else {
          charge['chargeBillingAmount'] = 0
          this._view.rowData.push(charge)
        }
        if (charge._charge) {
          charge._charge.chargeBillingAmount = charge.chargeBillingAmount
        }
      } else {
        // charge['amount'] = charge['chargeAmount']
        // charge['currency'] = charge['chargeCurrency']
        // charge['inputDate'] = charge['chargeInputDate']
        // charge['dateCreated'] = charge['chargeDateCreated']
        // this._view.rowData = lodash.cloneDeep(BillingNativeUtils.appendJobCharges(charge, this._view.rowData))
      }
      // 判断账单是否为国内账单，如果满足，则重新计算账单的收支类型
      if (billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        billing.ar = isReceivable(this.getAllCharges(), billing.makeBillingPaymentReceiveMethod)
      }
      await this.refreshBilling()
      this.filterChange()
    }
  }
  // 删除费用/删除全部
  async removeBillChargeEvent() {
    if (this._view.billing.source === ChargeConstants.ETOWER_ONE.chineseName) {
      this.$message.warning(this.$t('CargoMsg.Cargo_BillNotAllowEditEtowerOne'))
      return
    }
    const chooseRows = getGridSelected(this._view.gridOptions)
    const removedChargeArray = this._view.billing.removedCharges
    const rowData = this._view.rowData
    if (rowData && chooseRows && rowData.length === chooseRows.length) {
      this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
      return
    }
    let refreshCurrency = false // 判断币种是否刷新
    if (this._view.reconciliationType === 'charge') {
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseNotSelected'))
        return
      }
      for (let i = 0; i < chooseRows.length; i++) {
        const selectItem = chooseRows[i]
        const index = rowData.indexOf(selectItem)
        if (index > -1) {
          rowData.splice(index, 1)
        }
        if (selectItem._charge && !selectItem._charge.uuid) {
          continue
        }
        selectItem['dirty'] = true
        selectItem['action'] = 2
        selectItem['billingUuid'] = null
        selectItem['billingNo'] = null
        removedChargeArray.push(selectItem)
      }
      if (this._view.billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        // 移除了第一笔费用完之后 ，如果新的账单币种与当前第一条币种不一致，则修改账单币种
        await cache.load(cacheName.CONFIG)
        const judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 0
        if (judgmentOfBillCurrency && this._view.billing.currency !== rowData[0].chargeCurrency) {
          this._view.billing.currency = rowData[0].chargeCurrency
          this._view.$refs['billForm'].changeOurBankByCurrency()
          refreshCurrency = true
        }
      }
    } else {
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BusinessNotSelected'))
        return
      }
      let charges = []
      for (let i = 0; i < chooseRows.length; i++) {
        const selectItem = chooseRows[i]
        if (selectItem.hasOwnProperty('charges') && selectItem['charges'] && selectItem['charges'].length > 0) {
          charges = charges.concat(selectItem['charges'])
        }
        for (let j = 0; j < rowData.length; j++) {
          const job = rowData[j]
          if (job['jobUid'] === selectItem['jobUid']) {
            const index = rowData.indexOf(selectItem)
            if (index > -1) {
              rowData.splice(index, 1)
              break
            }
          }
        }
      }
      await cache.load(cacheName.CONFIG)
      refreshCurrency = this.removeChargeByJob(rowData)
      if (charges.length > 0) {
        for (let j = 0; j < charges.length; j++) {
          const charge = charges[j]
          charge['dirty'] = true
          charge['action'] = 2
          charge['billingUuid'] = null
          charge['billingNo'] = null
          removedChargeArray.push(charge)
        }
      }
    }
    // 判断账单是否为国内账单，如果满足，则重新计算账单的收支类型
    if (this._view.billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
      this._view.billing.ar = isReceivable(this.getAllCharges(), this._view.billing.makeBillingPaymentReceiveMethod)
    }
    this.recalculateBilling()
    this.refreshRowData()
    await this.refreshBilling()
    this._view.billing.removedCharges = removedChargeArray
    if (refreshCurrency) { // 币种发生变更，需要重新计算
      await this.currencyChangeEvent({ value: this._view.billing.currency })
    }
    this.filterChange()
  }
  // 彻底删除费用
  async deleteBillChargeEvent(chooseRows) {
    if (this._view.billing.source === ChargeConstants.ETOWER_ONE.chineseName) {
      this.$message.warning(this.$t('CargoMsg.Cargo_BillNotAllowEditEtowerOne'))
      return
    }
    const removedChargeArray = this._view.billing.removedCharges
    const deletedChargeKeys = this._view.billing.deletedChargeKeys || []
    const rowData = this._view.rowData
    if (rowData && chooseRows && rowData.length === chooseRows.length) {
      this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
      return
    }
    let refreshCurrency = false // 判断币种是否刷新
    if (this._view.reconciliationType === 'charge') {
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseNotSelected'))
        return
      }
      for (let i = 0; i < chooseRows.length; i++) {
        const selectItem = chooseRows[i]
        const index = rowData.indexOf(selectItem)
        if (index > -1) {
          rowData.splice(index, 1)
        }
        if (selectItem._charge && !selectItem._charge.uuid) {
          continue
        }
        selectItem['dirty'] = true
        selectItem['action'] = 2
        selectItem['billingUuid'] = null
        selectItem['billingNo'] = null
        removedChargeArray.push(selectItem)
        deletedChargeKeys.push(selectItem.uuid)
      }
      if (this._view.billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        // 移除了第一笔费用完之后 ，如果新的账单币种与当前第一条币种不一致，则修改账单币种
        await cache.load(cacheName.CONFIG)
        const judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 0
        if (judgmentOfBillCurrency && this._view.billing.currency !== rowData[0].chargeCurrency) {
          this._view.billing.currency = rowData[0].chargeCurrency
          this._view.$refs['billForm'].changeOurBankByCurrency()
          refreshCurrency = true
        }
      }
    } else {
      // if (chooseRows.length === 0) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_BusinessNotSelected'))
      //   return
      // }
      // let charges = []
      // for (let i = 0; i < chooseRows.length; i++) {
      //   const selectItem = chooseRows[i]
      //   if (selectItem.hasOwnProperty('charges') && selectItem['charges'] && selectItem['charges'].length > 0) {
      //     charges = charges.concat(selectItem['charges'])
      //   }
      //   for (let j = 0; j < rowData.length; j++) {
      //     const job = rowData[j]
      //     if (job['jobUid'] === selectItem['jobUid']) {
      //       const index = rowData.indexOf(selectItem)
      //       if (index > -1) {
      //         rowData.splice(index, 1)
      //         break
      //       }
      //     }
      //   }
      // }
      // await cache.load(cacheName.CONFIG)
      // refreshCurrency = this.removeChargeByJob(rowData)
      // if (charges.length > 0) {
      //   for (let j = 0; j < charges.length; j++) {
      //     const charge = charges[j]
      //     charge['dirty'] = true
      //     charge['action'] = 2
      //     charge['billingUuid'] = null
      //     charge['billingNo'] = null
      //     removedChargeArray.push(charge)
      //   }
      // }
    }
    // 判断账单是否为国内账单，如果满足，则重新计算账单的收支类型
    if (this._view.billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
      this._view.billing.ar = isReceivable(this.getAllCharges(), this._view.billing.makeBillingPaymentReceiveMethod)
    }
    this.recalculateBilling()
    this.refreshRowData()
    await this.refreshBilling()
    this._view.billing.removedCharges = removedChargeArray
    this._view.billing.deletedChargeKeys = deletedChargeKeys
    if (refreshCurrency) { // 币种发生变更，需要重新计算
      await this.currencyChangeEvent({ value: this._view.billing.currency })
    }
    this.filterChange()
  }
  // 刷新国内账单费用信息
  async refreshInternalBillCharge() {
    let refreshCurrency = false // 判断币种是否刷新
    // 移除了第一笔费用完之后 ，如果新的账单币种与当前第一条币种不一致，则修改账单币种
    await cache.load(cacheName.CONFIG)
    const judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 0
    if (judgmentOfBillCurrency && this._view.billing.currency !== this._view.rowData[0].chargeCurrency) {
      this._view.billing.currency = this._view.rowData[0].chargeCurrency
      this._view.$refs['billForm'].changeOurBankByCurrency()
      refreshCurrency = true
    }
    // 国内账单重新计算账单的收支类型
    this._view.billing.ar = isReceivable(this.getAllCharges(), this._view.billing.makeBillingPaymentReceiveMethod)
    await this.refreshBilling()
    if (refreshCurrency) { // 币种发生变更，需要重新计算
      await this.currencyChangeEvent({ value: this._view.billing.currency })
    }
  }
  removeChargeByJob(rowData) {
    if (this._view.billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
      return false
    }
    // 移除了第一笔费用完之后 ，如果新的账单币种与当前第一条币种不一致，则修改账单币种
    const judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 0
    if (judgmentOfBillCurrency && this._view.billing.currency !== rowData[0]['charges'][0].chargeCurrency) {
      this._view.billing.currency = rowData[0]['charges'][0].chargeCurrency
      this._view.$refs['billForm'].changeOurBankByCurrency()
      return true
    }
    return false
  }
  // 查看/移除明细回调函数
  async removePartBillChargeCallBackEvent(removeItems) {
    const chooseRows = getGridSelected(this._view.gridOptions)
    const selectJob = chooseRows[0]
    const charges = selectJob['charges']
    let refreshCurrency = false // 判断币种是否刷新
    if (removeItems && removeItems.length > 0) {
      // 如果费用全部删除，则列表中的这一票业务也移除掉
      if (charges && charges.length > 0 && charges.length === removeItems.length) {
        const rowData = this._view.rowData
        for (let i = 0; i < rowData.length; i++) {
          const job = rowData[i]
          if (job['jobUid'] === selectJob['jobUid']) {
            const index = rowData.indexOf(job)
            if (index >= 0) {
              rowData.splice(index, 1)
              break
            }
          }
        }
        await cache.load(cacheName.CONFIG)
        refreshCurrency = this.removeChargeByJob(rowData)
      }
      for (let i = removeItems.length - 1; i >= 0; i--) {
        const removeCharge = removeItems[i]
        removeCharge['dirty'] = true
        removeCharge['action'] = 2
        removeCharge['billingUuid'] = null
        removeCharge['billingNo'] = null
        const newRemovedCharges = this._view.billing.removedCharges.concat(BillingNativeUtils.removeJobCharges(removeCharge, selectJob))
        this._view.billing.removedCharges = newRemovedCharges
      }
    }
    this.refreshRowData([selectJob])
    // 判断账单是否为国内账单，如果满足，则重新计算账单的收支类型
    if (this._view.billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
      this._view.billing.ar = isReceivable(this.getAllCharges(), this._view.billing.makeBillingPaymentReceiveMethod)
    }
    await this.refreshBilling()
    if (refreshCurrency) { // 币种发生变更，需要重新计算
      await this.currencyChangeEvent({ value: this._view.billing.currency })
    }
    this._view.showRemovePartBillChargeDialog = false
  }
  // 刷新列表数据
  refreshRowData(chooseRows) {
    if (chooseRows && chooseRows.length > 0) {
      const rowData = this._view.rowData
      for (let i = 0; i < rowData.length; i++) {
        const rowItem = rowData[i]
        for (let j = 0; j < chooseRows.length; j++) {
          const selectedRow = chooseRows[j]
          if (this._view.reconciliationType === 'charge') {
            if (rowItem['uuid'] && selectedRow['uuid'] && rowItem['uuid'] === selectedRow['uuid']) {
              rowData[i] = selectedRow
              break
            }
          } else { // 按业务刷新列表时，jobUid为每一行的唯一标识
            if (rowItem['jobUid'] && selectedRow['jobUid'] && rowItem['jobUid'] === selectedRow['jobUid']) {
              rowData[i] = selectedRow
              break
            }
          }
        }
      }
      this._view.rowData = lodash.cloneDeep(rowData)
    }
  }
  // 刷新帐单
  async refreshBilling() {
    await this.currencyChangeEvent(null)
    await this.fillChangedCurrency()
    await this.calculateAmount()
  }
  async otherBillingData() {
    if (this._view.billingFormParams.billingNoteContainInvoiceReques) {
      await BillingUtils.setBillingInvoiceInformation(this._view.billing, this.getAllCharges())
    }
  }
  // 重新计算账单金额，含税额以及分币种合计
  recalculateBilling() {
    const billing = this._view.billing
    const charges = this.getAllCharges()
    ReconciliationUtils.sumBillingAmount(billing, charges)
    ReconciliationUtils.groupCurrencyAmount(billing, charges)
  }
  // 计算账单金额等属性
  async calculateAmount() {
    const billing = this._view.billing
    const sourceCurrency1 = billing.sourceCurrency1
    const sourceCurrency2 = billing.sourceCurrency2
    const sourceCurrency3 = billing.sourceCurrency3
    let billingAmount = 0.00// 账单金额
    let excludingTaxAmountTotal = 0.00// 税金
    let amount1 = 0.00
    let amount2 = 0.00
    let amount3 = 0.00
    const charges = this.getAllCharges()
    if (charges && charges.length > 0) {
      const zeroAmountCurrencys = ChargeUtils.getZeroAmountCurrencys(charges, 'chargeCurrency', 'chargeAmount', 'chargeReceivable')
      for (let i = 0; i < charges.length > 0; i++) {
        const charge = charges[i]
        const chargeCurrency = charge.chargeCurrency
        const chargeReceivable = charge.chargeReceivable
        const chargeExcludingTaxAmount = charge.chargeExcludingTaxAmount
        const chargeTaxAmount = chargeReceivable ? chargeExcludingTaxAmount : -chargeExcludingTaxAmount
        const chargeAmount = isNaN(charge.chargeAmount) ? 0.00 : (chargeReceivable ? charge.chargeAmount : -charge.chargeAmount)
        if (sourceCurrency1 && sourceCurrency1 === chargeCurrency) {
          amount1 += chargeAmount
        }
        if (sourceCurrency2 && sourceCurrency2 === chargeCurrency) {
          amount2 += chargeAmount
        }
        if (sourceCurrency3 && sourceCurrency3 === chargeCurrency) {
          amount3 += chargeAmount
        }
        if (zeroAmountCurrencys.includes(chargeCurrency)) continue
        const rate = await this.getRate(chargeCurrency, billing)
        // billingAmount += NumberUtils.roundHalfUp(chargeAmount * rate)
        // excludingTaxAmountTotal += NumberUtils.roundHalfUp(((isNaN(chargeTaxAmount) ? 0 : chargeTaxAmount) * rate), 2)
        // CARGO-25843，海运进出口涉及日币收费的费用计算方式更改
        billingAmount += NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(chargeAmount * rate, billing.currency), 2)
        excludingTaxAmountTotal += NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(((isNaN(chargeTaxAmount) ? 0 : chargeTaxAmount) * rate), billing.currency), 2)
        billingAmount = RateUtil.getAmountByCurrency(billingAmount, billing.currency)
        excludingTaxAmountTotal = RateUtil.getAmountByCurrency(excludingTaxAmountTotal, billing.currency)
      }
    }
    billing.amount = billing.ar ? billingAmount : -billingAmount
    // billing.taxAmount = billing.ar ? NumberUtils.roundHalfUp((billingAmount - excludingTaxAmountTotal), 2) : NumberUtils.roundHalfUp((excludingTaxAmountTotal - billingAmount), 2)
    // billing.taxFreeAmount = billing.amount - billing.taxAmount
    billing.taxAmount = billing.ar ? NumberUtils.ToFixed2(RateUtil.getAmountByCurrency((billingAmount - excludingTaxAmountTotal), billing.currency), 2) : NumberUtils.ToFixed2(RateUtil.getAmountByCurrency((excludingTaxAmountTotal - billingAmount), billing.currency), 2)
    billing.taxFreeAmount = RateUtil.getAmountByCurrency(billing.amount - billing.taxAmount, billing.currency)
    billing.amount1 = billing.ar ? amount1 : -amount1
    billing.amount2 = billing.ar ? amount2 : -amount2
    billing.amount3 = billing.ar ? amount3 : -amount3
  }
  // 打印事件
  printEvent() {
  }
  //  自定义汇率
  async fillChangedCurrency() {
    const billing = this._view.billing
    if (!billing) return
    const currencyMap = new Map()
    const charges = this.getAllCharges()
    if (charges && charges.length > 0) {
      for (let i = 0; i < charges.length > 0; i++) {
        const charge = charges[i]
        const chargeCurrency = charge['chargeCurrency']
        if (!currencyMap.has(chargeCurrency)) {
          if (chargeCurrency === billing.currency) {
            currencyMap.set(chargeCurrency, 1.0)
          } else {
            let rate = NaN
            if (chargeCurrency === billing.sourceCurrency1) {
              rate = billing.sourceRate1
            }
            if (chargeCurrency === billing.sourceCurrency2) {
              rate = billing.sourceRate2
            }
            if (chargeCurrency === billing.sourceCurrency3) {
              rate = billing.sourceRate3
            }
            if (!rate || !isNaN(rate)) {
              rate = await this.getRate(chargeCurrency, billing)
            }
            currencyMap.set(chargeCurrency, rate)
          }
        }
      }
    }
    // 先重置几个输入框
    let sourceCurrency1 = ''
    let sourceCurrency2 = ''
    let sourceCurrency3 = ''
    let sourceRate1 = 0.0
    let sourceRate2 = 0.0
    let sourceRate3 = 0.0
    let index = 1
    currencyMap.forEach(function(value, key) {
      if (index <= 3) {
        if (index === 1) {
          sourceCurrency1 = key
          sourceRate1 = value
        } else if (index === 2) {
          sourceCurrency2 = key
          sourceRate2 = value
        } else if (index === 3) {
          sourceCurrency3 = key
          sourceRate3 = value
        }
        index++
      }
    })
    if (sourceCurrency1) {
      billing.sourceRate1 = sourceRate1
      if (sourceRate1 > 0) {
        this._view.billingFormParams.sourceRate1Enable = false
      } else {
        this._view.billingFormParams.sourceRate1Enable = true
      }
    } else {
      billing.sourceRate1 = 0.00
      this._view.billingFormParams.sourceRate1Enable = true
    }
    if (sourceCurrency2) {
      billing.sourceRate2 = sourceRate2
      if (sourceRate2 > 0) {
        this._view.billingFormParams.sourceRate2Enable = false
      } else {
        this._view.billingFormParams.sourceRate2Enable = true
      }
    } else {
      billing.sourceRate2 = 0.00
      this._view.billingFormParams.sourceRate2Enable = true
    }
    if (sourceCurrency3) {
      billing.sourceRate3 = sourceRate3
      if (sourceRate3 > 0) {
        this._view.billingFormParams.sourceRate3Enable = false
      } else {
        this._view.billingFormParams.sourceRate3Enable = true
      }
    } else {
      billing.sourceRate3 = 0.00
      this._view.billingFormParams.sourceRate3Enable = true
    }
    // 如果账单币种和原币种相同，则汇率不可编辑
    if (billing.currency === sourceCurrency1) {
      this._view.billingFormParams.sourceRate1Enable = true
    }
    if (billing.currency === sourceCurrency2) {
      this._view.billingFormParams.sourceRate2Enable = true
    }
    if (billing.currency === sourceCurrency3) {
      this._view.billingFormParams.sourceRate3Enable = true
    }
    billing.sourceCurrency1 = sourceCurrency1
    billing.sourceCurrency2 = sourceCurrency2
    billing.sourceCurrency3 = sourceCurrency3
  }
  // 费用冲突弹窗回调函数
  conflictChargeCallBackEvent(result) {
    this._view.showConflictChargeDialog = false
    if (result && result['type']) {
      this.continueSave(result['charges']).then()
    }
  }
  // 获取汇率
  async getRate(chargeCurrency, billing) {
    let currencyRate = 0.00
    if (chargeCurrency && billing) {
      const currency = billing.currency
      const sourceCurrency1 = billing.sourceCurrency1
      const sourceCurrency2 = billing.sourceCurrency2
      const sourceCurrency3 = billing.sourceCurrency3
      if (chargeCurrency === currency) {
        currencyRate = 1.0
      } else {
        if (this._view.isSaveBillRate) {
          currencyRate = await BillingRateUtil.getForeignExchangeRateByDate(currency, chargeCurrency, billing.inputDate, null, false)
        } else {
          currencyRate = await RateUtil.getForeignExchangeRateByDate(currency, chargeCurrency, billing.inputDate, billing.branchId, null, false)
        }
        if (sourceCurrency1 && sourceCurrency1 === chargeCurrency) {
          if (billing.sourceRate1) {
            currencyRate = billing.sourceRate1
          } else {
            billing.sourceRate1 = currencyRate
          }
          return currencyRate
        }
        if (sourceCurrency2 && sourceCurrency2 === chargeCurrency) {
          if (billing.sourceRate2) {
            currencyRate = billing.sourceRate2
          } else {
            billing.sourceRate2 = currencyRate
          }
          return currencyRate
        }
        if (sourceCurrency3 && sourceCurrency3 === chargeCurrency) {
          if (billing.sourceRate3) {
            currencyRate = billing.sourceRate3
          } else {
            billing.sourceRate3 = currencyRate
          }
          return currencyRate
        }
      }
    }
    return currencyRate
  }
  // 校验账单
  async validateBilling() {
    const billing = this._view.billing
    const charges = this.getAllCharges()
    if (!charges || charges.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseItemsCanTBeEmpty'))
      return false
    }
    if ((billing.sourceCurrency1 && !billing.sourceRate1) || (billing.sourceCurrency2 && !billing.sourceRate2) || (billing.sourceCurrency3 && !billing.sourceRate3)) {
      this.$message.warning(this.$t('CargoMsg.Cargo_BillRateEmpty'))
      return false
    }
    const keys = []
    const currencyArray = [] // 统计账单费用币种
    for (let i = 0; i < charges.length; i++) {
      const charge = charges[i]
      const key = charge['uuid']
      const chargeCurrency = charge['chargeCurrency']
      if (key && keys.indexOf(key) < 0) {
        keys.push(key)
      }
      if (chargeCurrency && currencyArray.indexOf(chargeCurrency) < 0) {
        currencyArray.push(chargeCurrency)
      }
    }
    if (currencyArray.length > 3) {
      this.$message.warning(this.$t('CargoMsg.Cargo_BillCurrencyMore'))
      return false
    }
    // 是否允许多币种创建账单(参数只能在这里获取，原因是业务模块也会调用此方法)
    await cache.load(cacheName.CONFIG)
    const judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 1
    if (judgmentOfBillCurrency && currencyArray.length > 1) {
      this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyMustBeTheSame'))
      return false
    }
    let passThrough = true
    if (keys && keys.length > 0) {
      // 加载数据库中的费用，已此为验证标准
      const realCharges = await loadCharges({ chargeKeys: keys }).then(res => {
        return res.data
      }).finally(() => {})
      if (realCharges && realCharges.length > 0) {
        for (let i = 0; i < realCharges.length; i++) {
          const charge = realCharges[i]
          if (charge['offsetState'] === 1 || charge['offsetState'] === 2) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OFTRFOTARFCBIITB'))
            passThrough = false
            break
          }
        }
        if (!passThrough) return passThrough
      }
      if (!realCharges || realCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseItemsCanTBeEmpty'))
        return false
      }
    }
    for (let i = 0; i < charges.length; i++) {
      const charge = charges[i]
      if (charge['chargeCurrency'] !== billing.currency) {
        let rate = 0
        if (this._view.isSaveBillRate) {
          rate = await BillingRateUtil.getForeignExchangeRateSafely(billing.currency, charge['chargeCurrency'], billing.inputDate)
        } else {
          rate = await RateUtil.getForeignExchangeRateSafely(billing.currency, charge['chargeCurrency'], billing.inputDate, billing.branchId)
        }
        if (isNaN(rate) || rate === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CERNM', [billing.currency]))
          passThrough = false
          break
        }
      }
    }
    if (!passThrough) return passThrough
    if (billing.ar && !billing.title && billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
      this.$message.warning(this.$t('CargoMsg.Cargo_InvoicingHeadCannotBeEmpty'))
      return false
    }
    if (!billing.currency) {
      this.$message.warning(this.$t('CargoMsg.Cargo_BillCurrencyEmpty'))
      return false
    }
    if (billing.settlementAgentId <= 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_SettlementAgentEmpty'))
      return false
    }
    let checkBranch = true
    for (let i = 0; i < charges.length; i++) {
      checkBranch = await SecurityUtil.checkChargeDetailBranch(charges[i].chargeBranchId)
      if (!checkBranch) {
        break
      }
    }
    if (!checkBranch) {
      this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
      return false
    }
    return true
  }
  // 获取所有费用
  getAllCharges(list) {
    let charges = []
    // 判断是按业务编辑还是按费用编辑
    let rowData
    if (list) {
      rowData = list
    } else {
      rowData = this._view.rowData
    }
    if (this._view.reconciliationType === 'charge') {
      charges = rowData
    } else {
      for (let i = 0; i < rowData.length; i++) {
        const job = rowData[i]
        const jobCharges = job['charges']
        if (jobCharges && jobCharges.length > 0) {
          charges = charges.concat(jobCharges)
        }
      }
    }
    return charges
  }
  // 查询账单详情
  queryBillingDetail(params) {
    params = params || {}
    this._view.loading = getLoading()
    getBillingDetail(this._view.billingUuid).then(res => {
      this._view.billing = { ... res.data }
      this._view.billing.currentOfficeId = this.$store.getters.currentOfficeId // 当前分公司
      this._view.createBillWay = this._view.billing.createBillWay
      if (this._view.createBillWay === 1) {
        this._view.searchItemModule = '5044'
      }
      const billing = this._view.billing
      billing.removedCharges = []
      billing.createCharges = []
      billing.updateCharges = []
      this._view.billingFormParams.isShowCounterPartyBillingNo = billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code
      // this._view.showBillForm = true
      this.checkBillingRateEditable()
      // 默认查询对账单关联的账单信息
      const uuid = billing.uuid
      if (uuid) {
        const requires = params.requires || []
        if (this._view.reconciliationType === 'job') {
          this.queryJobOfBilling({ requires })
        } else if (this._view.reconciliationType === 'charge') {
          this.queryChargeOfBilling({ requires })
        }
      }
      this.querySettlement(billing.accountId)
    }).finally(() => {
      this._view.loading.close()
    })
  }
  // 根据结算对象ID获取结算对象
  querySettlement(accountId = 0) {
    const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(accountId))
    if (company) {
      if (this.$store.getters.language === 'zh') {
        this._view.billing.settlement = company['chineseName']
      } else {
        this._view.billing.settlement = company['englishName']
      }
    }
  }
  // 查询账单关联的业务信息
  queryJobOfBilling(params) {
    params = params || {}
    const requires = params.requires || []
    const requestBody = { branchId: this.$store.getters.currentOfficeId, requestSource: 'BillingDetail_Job', requires }
    if (this._view.billing.uuid) { // 针对于已经创建好的账单查询
      requestBody.billingKey = this._view.billing.uuid
    } else { // 针对于新增未保存的账单查询,根据费用UUID查询
      requestBody.chargeKeys = this._view.newCharges
    }
    requestBody.pageNum = this._view.searchConditions.pageNum
    requestBody.pageSize = this._view.searchConditions.pageSize
    loadJobOfBilling(requestBody).then(async res => {
      if (res.data.list && res.data.list.length > 0) {
        this._view.rowData = [...res.data.list]
        let charges = []
        for (let i = 0; i < res.data.list.length; i++) {
          const job = res.data.list[i]
          const jobCharges = job['charges']
          if (jobCharges && jobCharges.length > 0) {
            charges = charges.concat(jobCharges)
          }
        }
        this._view.totalAmountToCurrency.dataProvider = charges
        this._view.totalAmountToCurrency.labelText = this.getRPLabel(charges)
      } else {
        this._view.rowData = []
        this._view.totalAmountToCurrency.dataProvider = []
        this._view.totalAmountToCurrency.labelText = ''
        this._view.totalAmountToCurrency.selectionCountLabel = ''
      }
      this._view.searchConditions.total = Number(res.data.total)
      // 新建账单时，加载费用明细后重新计算账单
      if (this._view.billing && !this._view.billing.uuid) {
        await this.otherBillingData()
        await this.refreshBilling()
      }
    }).finally(() => {
      if (this._view.loading) {
        this._view.loading.close()
      }
    })
  }
  // 查询账单关联的费用信息
  queryChargeOfBilling(params) {
    params = params || {}
    const requires = params.requires || []
    const requestBody = { branchId: this.$store.getters.currentOfficeId, requestSource: 'BillingDetail_Charge', requires }
    if (this._view.billing.uuid) { // 针对于已经创建好的账单查询
      requestBody.billingKey = this._view.billing.uuid
    } else { // 针对于新增未保存的账单查询,根据费用UUID查询
      requestBody.chargeKeys = this._view.newCharges
    }
    requestBody.pageNum = this._view.searchConditions.pageNum
    requestBody.pageSize = this._view.searchConditions.pageSize
    loadChargeOfBilling(requestBody).then(async res => {
      if (res.data.list && res.data.list.length > 0) {
        this._view.rowData = [...res.data.list]
        this._view.totalAmountToCurrency.dataProvider = res.data.list
        this._view.totalAmountToCurrency.labelText = this.getRPLabel(res.data.list)
      } else {
        this._view.rowData = []
        this._view.totalAmountToCurrency.dataProvider = []
        this._view.totalAmountToCurrency.labelText = ''
        this._view.totalAmountToCurrency.selectionCountLabel = ''
      }
      this._view.searchConditions.total = Number(res.data.total)
      // 新建账单时，加载费用明细后重新计算账单
      if (this._view.billing && !this._view.billing.uuid) {
        await this.otherBillingData()
        await this.refreshBilling()
      }
    }).finally(() => {
      if (this._view.loading) {
        this._view.loading.close()
      }
    })
  }
  // 校验账单汇率是否可编辑
  checkBillingRateEditable() {
    const billing = this._view.billing
    if (billing) {
      const isView = this._view.isView
      const sourceCurrency1 = billing.sourceCurrency1
      const sourceCurrency2 = billing.sourceCurrency2
      const sourceCurrency3 = billing.sourceCurrency3
      const currency = billing.currency
      if (sourceCurrency1 && sourceCurrency1 !== currency) {
        this._view.billingFormParams.sourceRate1Enable = isView
      } else {
        this._view.billingFormParams.sourceRate1Enable = true
      }
      if (sourceCurrency2 && sourceCurrency2 !== currency) {
        this._view.billingFormParams.sourceRate2Enable = isView
      } else {
        this._view.billingFormParams.sourceRate2Enable = true
      }
      if (sourceCurrency3 && sourceCurrency3 !== currency) {
        this._view.billingFormParams.sourceRate3Enable = isView
      } else {
        this._view.billingFormParams.sourceRate3Enable = true
      }
    }
  }
  // 合计显示应收、应付
  getRPLabel(result) {
    let total1 = 0
    let total2 = 0
    if (result != null && result.length > 0) {
      for (const item of result) {
        if (item.chargeReceivable) {
          total1 += Number(item['chargeAmount'])
        } else {
          total2 += Number(item['chargeAmount'])
        }
      }
    }
    return total2 > total1 ? this.$t('CargoMsg.Cargo_DuesB') : this.$t('CargoMsg.Cargo_ReceivableB')
  }

  // 列表checkBox选中变更事件
  filterChange() {
    this._view.showData = true
    const selections = getGridSelected(this._view.gridOptions)
    if (selections.length > 0) {
      this.refreshSelectedCount(0, selections)
    } else {
      this.$nextTick(() => {
        const hasDisplay = []
        this._view.gridOptions.api.forEachNode(node => {
          if (node.displayed) {
            hasDisplay.push(node.data)
          }
        })
        if (hasDisplay.length > 0) {
          if (hasDisplay.length == this._view.rowData.length) {
            this.refreshSelectedCount()
          }
          if (hasDisplay.length < this._view.rowData.length) {
            this.refreshSelectedCount(1, hasDisplay)
          }
        } else {
          this._view.showData = false
          this.refreshSelectedCount(1, hasDisplay)
        }
      })
    }
  }
  refreshSelectedCount(arg, selections) {
    if (arg == 0) {
      let charges = []
      if (this._view.reconciliationType === 'charge') {
        charges = selections
      } else {
        for (let i = 0; i < selections.length; i++) {
          const job = selections[i]
          const jobCharges = job['charges']
          if (jobCharges && jobCharges.length > 0) {
            charges = charges.concat(jobCharges)
          }
        }
      }
      this._view.totalAmountToCurrency.dataProvider = charges
      this._view.totalAmountToCurrency.selectionCountLabel = this.$t('CargoMsg.Cargo_ChooseP', [selections.length])
      this._view.totalAmountToCurrency.labelText = this.getRPLabel(charges)
    } else if (arg === 1) {
      this._view.totalAmountToCurrency.dataProvider = this.getAllCharges(selections)
      this._view.totalAmountToCurrency.selectionCountLabel = ''
    } else {
      this._view.totalAmountToCurrency.dataProvider = this.getAllCharges()
      this._view.totalAmountToCurrency.selectionCountLabel = ''
    }
  }

  // 校验开票抬头和结算代理是否一致提示
  checkAgentAndTitle() {
    const charges = this._view.rowData
    if (!charges || charges.length === 0) {
      return false
    }
    const isJob = this._view.reconciliationType !== 'charge'
    const sameTitle = isJob ? ReconciliationUtils.isSameInvoiceTitleByJob(charges) : ReconciliationUtils.isSameInvoiceTitle(charges)
    const sameSettlementAgent = isJob ? ReconciliationUtils.isSameSettlementAgentByJob(charges) : ReconciliationUtils.isSameSettlementAgent(charges)
    let message = ''
    if (!sameTitle && !sameSettlementAgent) {
      message = this.$t('Message.SettlingAgentInvoiceTitleInconsistent')
    } else if (sameTitle && !sameSettlementAgent) {
      message = this.$t('Message.SettlingAgentInconsistent')
    } else if (!sameTitle && sameSettlementAgent) {
      message = this.$t('Message.TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue')
    }
    return message
  }
  // 校验商务报价、商务取消报价
  async checkCanSave() {
    const itemList = this._view.rowData
    let message = ''
    if (this._view.reconciliationType === 'charge') {
      for (const item of itemList) {
        // 若费用的报价确认为否
        if (item.chargeBusinessQuotationAmount > 0 && !item.chargeBusinessQuotationConfirmd) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeChargeItemId)
          message = this.$t('CargoMsg.Cargo_UnconfirmedSum', [item.jobJobNo, chargeItem.zhName, item.chargeCurrency, item.chargeAmount])
          break
        }
      }
    } else {
      for (const job of itemList) {
        if (job && job.charges) {
          for (const item of job.charges) {
            // 若费用的报价确认为否
            if (item.chargeBusinessQuotationAmount > 0 && !item.chargeBusinessQuotationConfirmd) {
              const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeChargeItemId)
              message = this.$t('CargoMsg.Cargo_UnconfirmedSum', [item.jobJobNo, chargeItem.zhName, item.chargeCurrency, item.chargeAmount])
              break
            }
          }
          if (message) {
            break
          }
        }
      }
    }
    return message
  }
}
